<ng-container *ngIf="resources.includes('*') && !tags.length && !isLoading">
  <mat-card class="allTags"
    >All Tags Selected <sn-icon fontSet="fal" fontIcon="fa-circle-check"></sn-icon
  ></mat-card>
</ng-container>

<ng-container *ngIf="!resources.includes('*') && tags.length && !isLoading">
  <mat-card class="mat-elevation-z2 tag-card" *ngFor="let tag of tags">
    {{ tag.name }}
  </mat-card>
</ng-container>

<ng-container *ngIf="!resources.includes('*') && !tags.length && isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-container>
